export const bitrix24MarketAppUrl = (domain?: string) =>
  domain?.endsWith('.by')
    ? 'https://www.bitrix24.by/apps/app/5757539.callbee_by/'
    : 'https://www.bitrix24.ru/apps/app/5757539.callbee/'
